import { DatePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment.development';
import { Api } from '../../services/api';
import { catchError, of, timeout } from 'rxjs';

@Component({
  selector: 'app-footer',
  imports: [
    RouterLink,
    DatePipe
  ],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {
  private api = inject(Api);
  
  today: Date = new Date();
  timezone: string = environment.timezone;
  sitename = signal<string | null>('');
  tagline = signal<string | null>('');
  address = signal<string | null>('');

  private initialize() : void {
    this.api.getOptimizeHome()
    .pipe(
      timeout(10000),
      catchError(() => of({
        site: {
          name: null,
          tagline: null,
          address: null,
        },
      }))
    ).subscribe(obj => {
      this.sitename.set(obj.site.name!);
      this.tagline.set(obj.site.tagline);
      this.address.set(obj.site.address!);
    });
  }

  ngOnInit() : void {
    this.initialize();
  }
}
